import { z } from "zod";

export const AnexarDocumentosSchema = z.object({
  idProjetoArquivo: z.number().int().default(0),
  idProjeto: z.number().optional().nullable(),
  nome: z.string().optional().nullable(),
  limparArquivo: z.boolean().optional().nullable(),
  descricao: z.string().nullable(),
  arquivo: z.instanceof(File).optional(),
});

export type AnexarDocumentosForm = z.infer<typeof AnexarDocumentosSchema>;
